import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useRouter, ROUTES } from '../../providers/router';
import { SelectionList } from '../../components/selection-list';
import { Levels } from '../../constants';

export const Locations = () => {
  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarLocationViewed);
    datadogRum.addAction(AnalyticEvents.sarLocationViewed);
  }, []);

  const { completeFormStep } = useRouter();

  const handleNextRoute = (dataSubset: any) => {
    completeFormStep(ROUTES.LOCATIONS, dataSubset);
  };

  return <SelectionList level={Levels.Location} handleNextRoute={handleNextRoute} />;
};

export default Locations;
